import { Pipe, PipeTransform } from '@angular/core';
import { ScheduleCalendarTime } from '@libs/store';
import { HourToDayPartPipe, HourToDayPartHourPipe } from '@libs/utils';
import { PadStartPipe } from '../pad-start';

@Pipe({
  name: 'timeRangeFormat',
  standalone: true,
})
export class TimeRangeFormatPipe implements PipeTransform {
  private readonly hourToDayPartPipe = new HourToDayPartPipe();
  private readonly hourToDayPartHourPipe = new HourToDayPartHourPipe();
  private readonly padStartPipe = new PadStartPipe();

  public transform(fromTime: ScheduleCalendarTime, toTime: ScheduleCalendarTime): string {
    const fromHourFormatted = this.hourToDayPartHourPipe.transform(fromTime.hour);
    const fromMinuteFormatted = fromTime.minute === 0 ? '' : `:${this.padStartPipe.transform(fromTime.minute, 2, '0')}`;
    const fromDayPart = this.hourToDayPartPipe.transform(fromTime.hour);

    const toHourFormatted = this.hourToDayPartHourPipe.transform(toTime.hour);
    const toMinuteFormatted = toTime.minute === 0 ? '' : `:${this.padStartPipe.transform(toTime.minute, 2, '0')}`;
    const toDayPart = this.hourToDayPartPipe.transform(toTime.hour);

    return `${fromHourFormatted}${fromMinuteFormatted} ${fromDayPart} - ${toHourFormatted}${toMinuteFormatted} ${toDayPart}`;
  }
}
